module Meevo.Components.Common {

    export class CommonPrintService implements IPrintService {
        constructor(
            private dataService: Meevo.Components.BaseClasses.IDataService,
            private modalService: Meevo.Components.Modal.IModalService,
            private $rootScope: ng.IRootScopeService,
            private $cookies: angular.cookies.ICookiesService,
            private $q: angular.IQService,
            private $timeout: angular.ITimeoutService,
            private $window: angular.IWindowService,
            private securityService: Meevo.Components.Common.ISecurityService,
            private printProxyService: Meevo.Components.Common.IPrintProxyService,
            private $mdToast: angular.material.IToastService,
            private appSettings: Meevo.Components.Common.IAppSettings
        ) {
            $rootScope.$on(Meevo.Components.Common.Messages.POS_HARDWARE_UPDATED, (event, args, params) => {
                this.printerList = null;
            });
        }

        private SystemPrinter: IPrintServicePrinter = {
            id: emptyGuid(),
            brandId: 3,
            displayName: "System Printer",
            deviceName: "System Printer",
            ribbonSize: 3,
            ipAddress: null,
            port: 0,
            isCustomerDisplayEnabled: false,
            isTrustEnabled: false,
        };
        private selectedPrinter: IPrintServicePrinter = this.SystemPrinter;
        private selectedTerminal: Meevo.Model.MerchantTerminal = null;

        private printerList: IPrintServicePrinter[];
        private timeToDisplayMessage: number = 1500;
        private lastTerminalMessageTimeout;
        private messages = [];

        // this is to prevent a fast user jamming in pole display messages faster than the timeToDisplayMessage
        private pendingPoleDisplayMessage = false;

        getPrinterList(): angular.IPromise<IPrintServicePrinter[]> {
            let defer = this.$q.defer<IPrintServicePrinter[]>();
            if (this.printerList && this.printerList.length > 0) {
                defer.resolve(this.printerList);
            }
            else {
                this.securityService.checkSecurityKey(Meevo.Components.Common.SecurityKeys.REGISTER_POSHARDWARE_TAB_RECEIPTPRINTER + Meevo.Components.Common.SecurityParts.KEY_PART_READ).then((permission) => {
                    if (permission !== Meevo.Model.SecurityAccessEnum.Grant) {
                        this.printerList = [this.SystemPrinter];
                        this.selectedPrinter = this.printerList[0];
                        defer.resolve(this.printerList);
                        return defer.promise;
                    }

                    var promises: ng.IPromise<any>[] = [
                        this.dataService.customMethodData("api/PosHardware/Printer/List/", "GET", null),
                        this.dataService.customMethodData("api/session/DrawerPreferences", "GET", null)
                    ];

                    let posStationId = this.$cookies.get("POSStation");
                    if (posStationId != null) {
                        promises.push(this.dataService.customMethodData(`api/PosHardware/device/${posStationId}?DeviceType=${Meevo.Model.DeviceTypeEnum.PosStation}`, "GET", null));
                    }

                    var printerList = [];
                    this.$q.all(promises).then((response) => {
                        printerList.push(this.SystemPrinter);

                        response[0].data.devices.forEach(device => {
                            printerList.push(device);
                        })

                        var posData: any = null;
                        if (response.length > 2) {
                            posData = response[2].data;
                        }

                        var receiptPrinter: any = null;
                        if (posData) {
                            if (posData.useNetworkPrinter) {
                                receiptPrinter = printerList[0];
                            }
                            else {
                                if (posData.devicePrinterId != null) {
                                    receiptPrinter = _.findWhere(printerList, { id: posData.devicePrinterId });
                                }
                            }
                        }
                        if (!receiptPrinter) {
                            var drawerPreferences = response[1].data;
                            if (drawerPreferences.lastUsedPrinterId) {
                                receiptPrinter = _.findWhere(printerList, { id: drawerPreferences.lastUsedPrinterId });
                            }
                        }
                        if (!receiptPrinter) {
                            receiptPrinter = printerList[0];
                        }
                        if (receiptPrinter) {
                            this.selectedPrinter = receiptPrinter;
                        }

                        this.printerList = printerList;
                        defer.resolve(this.printerList);
                    });
                });
            }

            return defer.promise;
        }

        getSelectedPrinter(): angular.IPromise<IPrintServicePrinter> {
            return this.$q.resolve(this.selectedPrinter);
        }

        setSelectedPrinter(printer: IPrintServicePrinter): angular.IPromise<void> {
            if (!printer || !printer.id) {
                this.selectedPrinter = this.printerList[0];
            } else {
                this.selectedPrinter = _.findWhere(this.printerList, { id: printer.id }) || this.printerList[0];
            }
            this.$rootScope.$broadcast(Components.Common.Messages.PRINTER_SELECTED, {}, this.selectedPrinter);
            return this.$q.resolve();
        }

        setSelectedTerminal(terminal: Meevo.Model.MerchantTerminal): angular.IPromise<void> {
            this.selectedTerminal = terminal;
            return this.$q.resolve();
        }

        /* Print methods */
        print(...documentUrls: string[]): angular.IPromise<any> {
            return this.printToDevice(this.selectedPrinter, ...documentUrls);
        }

        printToDevice(printerDetail: IPrintServicePrinter, ...documentUrls: string[]): angular.IPromise<any> {
            return this.$q.all(documentUrls.map(url =>
                this.dataService.customMethodData(url, "GET", null, { format: this.getPrinterFormat(printerDetail), timeFormat: this.appSettings.APP_TIME_FORMAT, locale: this.appSettings.APP_COUNTRYID })))
                .then(responses => this.printMultiple(responses.map(response => response.data), printerDetail));
        }

        printCustom(...requestObjs: IHttpRequestObject[]): angular.IPromise<any> {
            return this.printCustomToDevice(this.selectedPrinter, ...requestObjs);
        }

        printCustomToDevice(printerDetail: IPrintServicePrinter, ...requestObjs: IHttpRequestObject[]): angular.IPromise<any> {
            return this.$q.all(requestObjs.map(requestObj => {
                requestObj.params = requestObj.params || {};
                requestObj.params.format = this.getPrinterFormat(printerDetail);

                return this.dataService.customMethodData(requestObj.url, requestObj.method, requestObj.data, requestObj.params);
            })).then(responses => this.printMultiple(responses.map(response => response.data), printerDetail));
        }

        private getPrinterFormat(printerDetail?: IPrintServicePrinter) {
            const printer = printerDetail || this.selectedPrinter;
            if (printer) {
                switch (printer.brandId) {
                    case 1:
                        return "epson";
                    case 2:
                        return "star";
                }
            }
            return "html";
        }

        private printMultiple(printerTexts: string[], printerDetail?: IPrintServicePrinter) {
            const printer = printerDetail || this.selectedPrinter;
            if (!printer || printer.brandId === 3) {
                this.systemPrintMultiple(printerTexts);
                return null;
            }

            const payload = () => {
                return {
                    message: printerTexts.join(''),
                };
            };

            var task = this.$q.defer();

            this.toast('Attempting Print...');

	        this.printProxy('print', payload, printer)
		        .then(response => {
			        this.toast('Print Successful');
			        task.resolve(response);
		        })
		        .catch(error => {
			        this.toast('Print Failed!');

			        if (error && error.payload && error.payload.statusDetail) {
				        if (printer.isTrustEnabled && error.payload.statusDetail === 'trust') {
					        const options: Meevo.Components.Modal.IModalOptions = {
						        templateUrl: "app/plugins/register/modals/printTrustModal.template.html",
						        controller: "meevo.plugins.register.PrintTrustModalController",
						        controllerAs: "vm",
						        bindToController: true,
						        locals: { printTrustRequest: printer }
					        }

					        this.modalService.showCustom(options).then(() => {
						        task.reject();
					        });
				        } else {
					        let message = this.convertPrintProxyError(error.payload.statusDetail);
					        this.modalService.alert(message).then(() => {
						        task.reject();
					        });
				        }
			        } else {
				        task.reject(error);
			        }
				});

            return task.promise;
        }

        private convertPrintProxyError(statusDetail) {
            switch (statusDetail) {
                case "printer_cover_open":
                    return "MESSAGE_PRINTER_COVER_OPEN";
                case "printer_busy":
                    return "MESSAGE_PRINTER_IS_BUSY";
                case "printer_paper_feed":
                    return "MESSAGE_PRINTER_PAPER_FEED_DEPRESSED";
                case "printer_mechanical_error":
                    return "MESSAGE_PRINTER_MECHANICAL_ERROR";
                case "printer_autocutter_error":
                    return "MESSAGE_PRINTER_AUTO_CUTTER_ERROR";
                case "printer_unrecoverable_error":
                    return "MESSAGE_PRINTER_UNRECOVERABLE_ERROR";
                case "printer_out_of_paper":
                    return "MESSAGE_PRINTER_NO_PAPER";
                case "printer_spooler_stopped":
                    return "MESSAGE_PRINTER_PAPER_SPOOLER_STOPPED";
            }
            console.debug('Unknown printer error', statusDetail);
            return "MESSAGE_UNABLE_TO_CONNECT_TO_PRINTER";
        }

        private systemPrintMultiple(printerTexts: string[]) {
            const iframeId = "systemPrinter";

            let printContent = $(`#${iframeId}`);
            if (printContent.length === 0) {
                printContent = $(`<iframe id="${iframeId}" name="${iframeId}">`).css({ position: 'absolute', height: 0, width: 0 });
                $('body').prepend(printContent);
            }

            const printerHtml = printerTexts.join(`<div style="page-break-after: always"></div>`);

            const frameHtml =
                `<html>
<head>
    <link href="https://fonts.googleapis.com/css?family=Libre+Barcode+39+Text" rel="stylesheet" />
    <style>
    body {
        font-family: 'Courier New';
        font-size: 12px;
    }
    .barcodeContainer {
        font-family: 'Libre Barcode 39 Text' !important;
        font-size: 30px;
        font-weight: 200;
        padding-bottom: 5px;
    }
    </style>
    <script>
        function systemPrinter() {
            window.setTimeout(function() {
                var result = document.execCommand('print', false, null);
                if (!result) window.print();
            });
        }
    </script>
</head>
<body onload="systemPrinter()">
    ${printerHtml}
</body>
</html>`;

            this.$window.setTimeout(() => {
                const frame = this.$window.frames[iframeId];
                frame.document.open();
                frame.document.write(frameHtml);
                frame.document.close();
            });
        }

        showStandbyMessage() {
            this.sendTerminalMessage(null);

            const printer = this.selectedPrinter;

            if (!printer || printer.brandId === 3 || !printer.isCustomerDisplayEnabled) {
                return null;
            }

            if (!printer.customerDisplayStandbyLine1 && !printer.customerDisplayStandbyLine2) {
                return null;
            }

            const message = {
                lines: [
                    { text: [printer.customerDisplayStandbyLine1], alignment: Meevo.Components.Common.PoleDisplayAlignment.Spaced },
                    { text: [printer.customerDisplayStandbyLine2], alignment: Meevo.Components.Common.PoleDisplayAlignment.Scrolling },
                ]
            };

            const payload = (initializeResponse) => {
                return {
                    line1: this.formatText(message.lines[0], initializeResponse.payload.deviceDetail.maxLineWidth),
                    line2: this.formatText(message.lines[1], initializeResponse.payload.deviceDetail.maxLineWidth),
                    marquee: message.lines[1].alignment === Meevo.Components.Common.PoleDisplayAlignment.Scrolling,
                };
            };

            return this.printProxy('poleMessage', payload, printer);
        }

        private sendTerminalMessage(message: any, isLastMessage: boolean = false) {
            if (!this.selectedTerminal || !this.selectedTerminal.isTerminalDisplay) {
                return;
            }

            let request: any = {
                merchantTerminalId: this.selectedTerminal.id,
                merchantAccountId: this.selectedTerminal.merchantAccountId,
            };

            // if message is null, then pole display will be cleared
            if (message) {
                request.terminalDisplayPrompt = {
                    line1: message.lines[0].text.join(" "),
                    line2: message.lines[1].text.join(" "),
                };
            }

            this.dataService.customMethodData(`/api/terminalDisplay`, "POST", request);

            if (isLastMessage) {
                this.$timeout.cancel(this.lastTerminalMessageTimeout);
                this.lastTerminalMessageTimeout = this.$timeout(() => {
                    if (this.messages.length === 0) {
                        this.sendTerminalMessage(null);
                    }
                }, this.timeToDisplayMessage);
            }
        }

        private startShowingMessages(printerDetail?: IPrintServicePrinter) {
            if (this.pendingPoleDisplayMessage) {
                return;
            }

            const isLastMessage = this.messages.length === 1;
            const message = this.messages.shift();
            if (!message) {
                return;
            }

            this.pendingPoleDisplayMessage = true;

            this.sendTerminalMessage(message, isLastMessage);

            const queueNextMessage = () => {
                this.$timeout(() => {
                    this.pendingPoleDisplayMessage = false;
                    this.startShowingMessages(printerDetail);
                }, this.timeToDisplayMessage);
            }

            const printer = printerDetail || this.selectedPrinter;
            if (!printer || printer.brandId === 3 || !printer.isCustomerDisplayEnabled) {
                queueNextMessage();
                return;
            }

            this.consolePoleMessage(message, 20);

            const payload = (initializeResponse) => {
                return {
                    line1: this.formatText(message.lines[0], initializeResponse.payload.deviceDetail.maxLineWidth),
                    line2: this.formatText(message.lines[1], initializeResponse.payload.deviceDetail.maxLineWidth),
                    marquee: message.lines[1].alignment === Meevo.Components.Common.PoleDisplayAlignment.Scrolling,
                    flush: message.flush,
                };
            };

            this.printProxy('poleMessage', payload, printer).finally(() => {
                queueNextMessage();
            });
        }

        private consolePoleMessage(message: Meevo.Components.Common.IPoleDisplayObject, maxLineWidth: number) {
            if (message && message.lines.length > 0) {
                console.log(`Pole Display : ${this.formatText(message.lines[0], maxLineWidth)}`);
                for (let i = 1; i < message.lines.length; i++) {
                    console.log(`             : ${this.formatText(message.lines[i], maxLineWidth)}`);
                }
            }
        }

        protected formatText(aLine: Meevo.Components.Common.IPoleDisplayLine, maxLineWidth: number) {
            maxLineWidth = maxLineWidth || 20;
            let text: string;
            switch (aLine.alignment) {
                case Meevo.Components.Common.PoleDisplayAlignment.Left:
                    text = aLine.text.join(" ");
                    text = text.substr(0, Math.min(maxLineWidth, text.length));
                    break;
                case Meevo.Components.Common.PoleDisplayAlignment.Right:
                    text = aLine.text.join(" ");
                    text = text.substr(0, Math.min(maxLineWidth, text.length)).padLeft(maxLineWidth, " ");
                    break;
                case Meevo.Components.Common.PoleDisplayAlignment.Spaced:
                    if (aLine.text.length > 1) {
                        text = "";
                        const spaceLen = Math.floor((maxLineWidth - aLine.text.join("").length) / (aLine.text.length - 1));
                        let i: number = 0;
                        for (; i < aLine.text.length - 1; i++) {
                            text += aLine.text[i];
                            text += String(" ").padRight(spaceLen, " ");
                        }
                        text += aLine.text[i];
                    }
                    else {
                        text = aLine.text.join(" ");
                        text = text.substr(0, Math.min(maxLineWidth, text.length));
                    }
                    break;
                default:
                    text = aLine.text.join(" ");
                    break;
            }

            return $('<div/>').text(text).html();
        }

        queueMessagesToPoleDisplay(...messages: Meevo.Components.Common.IPoleDisplayObject[]): void {
            this.queueMessagesToPoleDisplayToDevice(null, ...messages);
        }

        queueMessagesToPoleDisplayToDevice(printerDetail: IPrintServicePrinter, ...messages: Meevo.Components.Common.IPoleDisplayObject[]): void {
            messages.forEach(message => {
                this.messages.push(message);
            });

            this.startShowingMessages(printerDetail);
        }

        resetPoleDisplay(printerDetail?: IPrintServicePrinter): angular.IPromise<any> {
            this.sendTerminalMessage(null);

            const printer = printerDetail || this.selectedPrinter;

            if (printer == undefined || printer.brandId === 3) {
                return this.$q.reject();
            }

            return this.printProxy('resetDisplay', {}, printer);
        }

        openDrawer(printerDetail?: IPrintServicePrinter): angular.IPromise<any> {
            const printer = printerDetail || this.selectedPrinter;

            const task = this.$q.defer();

            if (!printer || printer.brandId === 3) {
                task.resolve();
                return task.promise;
            }

            console.time('drawer-pop');

            var popDrawerTimeout = this.$timeout(() => {
                task.reject('timeout');
                this.toast('Drawer Pop Timed Out!', true);
                console.timeEnd('drawer-pop');
            }, 15000);

            this.toast('Attempting Drawer Pop...');
            this.auditOpenDrawer(printerDetail, Meevo.Model.VerbEnum.PopRequest)
                .finally(() => {
                    this.toast('Drawer Pop Audited');
                    return this.printProxy('openDrawer', {}, printer)
                        .then(() => {
                            this.auditOpenDrawer(printerDetail, Meevo.Model.VerbEnum.Popped, 'Success');
                            task.resolve();
                            this.toast('Drawer Pop Successful');
                        })
                        .catch((response) => {
                            task.reject(response);
                            this.toast('Drawer Pop Failed!', true);
                        })
                        .finally(() => {
                            this.$timeout.cancel(popDrawerTimeout);
                            console.timeEnd('drawer-pop');
                        });
                });

            return task.promise;
        }

        protected auditOpenDrawer(printerDetail: IPrintServicePrinter, verb: Meevo.Model.VerbEnum, result?: string): ng.IPromise<any> {
            const printer = printerDetail || this.selectedPrinter;

            if (printer !== this.selectedPrinter || !printer.id) {
                return this.$q.resolve();
            }

            const postData = {
                id: printer.id,
                verb: verb,
                result: result || ''
            };

            return this.dataService.customMethodData(`/api/PosHardware/PopDrawer/${printer.id.toString()}`, "POST", postData);
        }

        protected toast(message, error: boolean = false) {
            console.log(message);
            /*
            var toast = this.$mdToast.simple();
            toast.theme(error ? "error-toast" : "success-toast");
            toast.textContent(message);
            toast.position("bottom right");
            //toast.parent(element.children()[0]);
            toast.hideDelay(5000);
            toast.action("X"); // Will close the toast when clicked.
            this.$mdToast.show(toast);
            */
        }

        protected printProxy(action: string, payloadCallback, printer: any) {
            let printProxyRequest = {
                ipAddress: printer.ipAddress,
                port: printer.port,
                id: printer.id,
                deviceName: printer.deviceName,
                isTrustEnabled: printer.isTrustEnabled,
                ribbonSize: printer.ribbonSize,
            } as IPrintSettings;

            switch (printer.brandId) {
                case 1:
                    printProxyRequest.deviceType = DeviceType.Epson;
                    break;
                case 2:
                    printProxyRequest.deviceType = DeviceType.Star;
                    break;
            }

            const task = this.$q.defer();

            const handleInitializeResponse = (initializeResponse) => {
                if (initializeResponse.payload.success) {
                    const payload = angular.isObject(payloadCallback)
                        ? payloadCallback
                        : payloadCallback.call(this, initializeResponse);

                    payload.deviceType = initializeResponse.payload.deviceType;
                    payload.initializeRequestId = initializeResponse.request.requestId;

                    this.printProxyService.postMessage(action, payload)
                        .then((response) => {
                            if (response.payload.success) {
                                task.resolve(response);
                            } else {
                                task.reject(response);
                            }
                        })
                        .catch((response) => {
                            task.reject(response);
                        });
                } else {
                    task.reject(initializeResponse);
                }
            };

            this.printProxyService.initialize(printProxyRequest)
                .then((initializeResponse) => {
                    handleInitializeResponse(initializeResponse);
                })
                .catch((initializeResponse) => {
                    switch (initializeResponse) {
                        case 'standalone':
                            this.modalService.alert("MESSAGE_PRINT_STANDALONE").then(() => {
                                task.reject(initializeResponse);
                            });
                            break;

                        case 'unexpected_https_upgrade':
                            this.modalService.alert("MESSAGE_PRINTPROXY_UNEXPECTED_HTTPS_UPGRADE").then(() => {
                                task.reject(initializeResponse);
                            });
                            break;

                        case 'popup_timeout':
                            const options: Meevo.Components.Modal.IModalOptions = {
                                templateUrl: "app/plugins/register/modals/printProxyModal.template.html",
                                controller: "meevo.plugins.register.PrintProxyModalController",
                                controllerAs: "vm",
                                bindToController: true,
                                locals: { printProxyRequest }
                            }

                            this.modalService.showCustom(options).then((response) => {
                                if (response === 'cancel') {
                                    return task.reject(initializeResponse);
                                }

                                if (angular.isObject(response)) {
                                    return handleInitializeResponse(response);
                                } else {
                                    this.modalService.alert("MESSAGE_UNABLE_TO_CONNECT_TO_PRINTER").then(() => {
                                        return task.reject(initializeResponse);
                                    });
                                }
                            });
                            break;

                        default:
                            task.reject(initializeResponse);
                            break;
                    }
                });

            return task.promise;
        }

        static factory(): Function {
            const svc = (
                dataService: Meevo.Components.BaseClasses.IDataService,
                modalService: Meevo.Components.Modal.IModalService,
                $rootScope: ng.IRootScopeService,
                $cookies: angular.cookies.ICookiesService,
                $q: angular.IQService,
                $timeout: angular.ITimeoutService,
                $window: angular.IWindowService,
                securityService: Meevo.Components.Common.ISecurityService,
                printProxyService: Meevo.Components.Common.IPrintProxyService,
                $mdToast: angular.material.IToastService,
                appSettings: Meevo.Components.Common.IAppSettings
            ) => new CommonPrintService(
                dataService,
                modalService,
                $rootScope,
                $cookies,
                $q,
                $timeout,
                $window,
                securityService,
                printProxyService,
                $mdToast,
                appSettings
            );

            svc.$inject = [
                "meevo.components.common.DataService",
                "meevo.components.modal.ModalService",
                "$rootScope",
                "$cookies",
                "$q",
                "$timeout",
                "$window",
                "meevo.components.common.SecurityService",
                "meevo.components.common.PrintProxyService",
                "$mdToast",
                "meevo.AppSettings"
            ];

            return svc;
        }
    }

    angular.module("meevo.components.common")
        .factory("meevo.components.common.CommonPrintService", CommonPrintService.factory());
}